import { DesignIcon } from '@monorepo/nova-icons';
import { Button, Stack, Typography, useTheme } from '@monorepo/nova-ui';
import { useConditionalLink } from '../../../hooks';

export const LogInButton = () => {
  const theme = useTheme();
  const Link = useConditionalLink();

  return (
    <Button
      aria-label="Log In"
      sx={{
        width: { xs: 'auto', md: 156 },
        height: { xs: 32, md: 42 },
        minWidth: { xs: 'auto', md: 156 },
        minHeight: { xs: 32, md: 42 },
        padding: { xs: '0 16px', md: '0 24px' },
        alignItems: 'center',
        gap: 6,
        borderRadius: 30,
        background: theme.palette.primary.main,
        whiteSpace: 'nowrap',
      }}
    >
      <Link href="/">
        <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: '6px' }}>
          <Typography
            sx={{
              color: theme.palette.text.opposite,
              margin: 0,
              flex: 0,
              alignSelf: 'center',
              fontSize: {
                xs: theme.typography.pxToRem(14),
                md: theme.typography.pxToRem(16),
              },
              fontWeight: 500,
              textTransform: 'none',
            }}
          >
            Log In
          </Typography>
          <DesignIcon
            iconName="CaretRight"
            sx={{
              color: theme.palette.text.opposite,
              height: { xs: 16, md: 20 },
              width: { xs: 16, md: 20 },
            }}
          />
        </Stack>
      </Link>
    </Button>
  );
};
